import { exchangeCodeForTokens, OpenIdConnectTokens } from 'wly-ecommerce-common';
import { logError } from './log';

export const fetchTokens = (tokenEndpoint: string): Promise<OpenIdConnectTokens> | null => {
  const urlParams = new URLSearchParams(window.location.search);
  const code = urlParams.get('code');
  const state = urlParams.get('state');
  const error = urlParams.get('error');

  if (error) {
    logError(`fetchTokens: Authorization error: ${error}`);
    return null;
  }

  if (!code || !state) {
    logError('fetchTokens: Missing code or state in URL parameters');
    return null;
  }

  return exchangeCodeForTokens(tokenEndpoint, code, state);
};
